// Password field with a show/hide eye toggle — ports the original .password-wrapper
// + window.togglePassword (auth.js). The icon swaps between "eye" and "eye-off",
// matching the original SVGs exactly.

import { useState } from 'react'
import type { ChangeEvent } from 'react'
import s from '../screens/auth.module.css'

const EYE = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

const EYE_OFF = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <path d="m6.12 6.12 11.76 11.76" />
  </svg>
)

interface PasswordInputProps {
  value: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  autoComplete?: string
}

export default function PasswordInput({ value, onChange, placeholder, autoComplete = 'current-password' }: PasswordInputProps) {
  const [show, setShow] = useState(false)
  return (
    <div className={s.passwordWrapper}>
      <input
        className={s.input}
        type={show ? 'text' : 'password'}
        placeholder={placeholder}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
      />
      <button
        type="button"
        className={s.passwordToggle}
        onClick={() => setShow((v) => !v)}
        aria-label={show ? 'Скрыть пароль' : 'Показать пароль'}
      >
        {show ? EYE_OFF : EYE}
      </button>
    </div>
  )
}
